/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AppointmentResignationReasonDto
 */
export interface AppointmentResignationReasonDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentResignationReasonDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResignationReasonDto
     */
    'reason': AppointmentResignationReasonDtoReasonEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AppointmentResignationReasonDtoReasonEnum {
    Service = 'SERVICE',
    Date = 'DATE',
    Price = 'PRICE',
    Other = 'OTHER'
}


